module.exports = __webpack_public_path__ + "static/media/S2N5-5.3b69a4ee.svg";